import LoadingDots from './loading-dots';

export {LoadingDots};

export default LoadingDots;
